import { TextLink } from '@pm2/text-component';
import { generateJsxKey, parseChildren } from '@utils/ast';
import { video23ToLatexPrinters, video23Printers, video23Parsers } from './spec.23video.js';
import { fontToLatexPrinters, fontPrinters, fontParsers } from './spec.font.js';
import { iGuideHtmlNodeLatexPrinters, iGuideHtmlNodeJsxPrinters, iGuideHtmlNodeParsers } from './spec.html.js';
import { imageToLatexPrinters, imagePrinters, imageParsers } from './spec.image.js';
import { medialibraryToLatexPrinters, medialibraryPrinters, medialibraryParsers } from './spec.medialibrary.js';
import { jsx } from 'react/jsx-runtime';

const parser = (node, context) => {
  const children = parseChildren(node, {
    ...iGuideHtmlNodeParsers,
    ...video23Parsers,
    ...medialibraryParsers,
    ...imageParsers,
    ...fontParsers,
    ...linkParsers
  }, context.depth + 1);
  return {
    nodeType: "link",
    href: node.getAttribute("href"),
    theme: node.classList.contains("type--primary") ? "primary" : node.classList.contains("type--text-button") ? "secondary" : undefined,
    children
  };
};
const linkParsers = {
  a: parser
};
const linkPrinters = {
  link: (node, context) => {
    return /*#__PURE__*/jsx(TextLink, {
      theme: node.theme,
      target: "_blank",
      rel: "noreferrer",
      href: node.href || undefined,
      children: context.printChildren(node.children, {
        ...iGuideHtmlNodeJsxPrinters,
        ...imagePrinters,
        ...video23Printers,
        ...medialibraryPrinters,
        ...fontPrinters,
        ...linkPrinters
      })
    }, generateJsxKey(context));
  }
};
const linkToLatexPrinters = {
  link: (node, context) => {
    const children = context.printChildren(node.children, {
      ...iGuideHtmlNodeLatexPrinters,
      ...imageToLatexPrinters,
      ...video23ToLatexPrinters,
      ...medialibraryToLatexPrinters,
      ...fontToLatexPrinters,
      ...linkToLatexPrinters
    }).join("");
    return `\\href{${node.href}}{${children.replaceAll("#", "\\#")}}`;
  }
};

export { linkParsers, linkPrinters, linkToLatexPrinters };
//# sourceMappingURL=spec.link.js.map
